module.exports = __webpack_public_path__ + "img/prefereplus.0e086972.png";